import { AskableIconLoading } from '@askable/ui/core/askable-icon';
import { type ReactNode, Suspense } from 'react';

export const LoadingSuspense = ({ children }: { children: ReactNode }) => {
  return <Suspense fallback={<AskableIconLoading isFullScreen />}>{children}</Suspense>;
};
